import React, { useState, useEffect } from "react";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import {
  ReferralFollowUpNotificationsHeader,
  contraceptiveRSFHeader,
} from "../components/HeaderAttribute";
import toast from "react-hot-toast";
import GridPage from "../components/GridPage";
import { useUserCapability } from "../components/ConstantReducerProvider";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
const Notifications = ({ closePopup, call }) => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [isLoading, setIsLoading] = useState(false);
  // Contraceptive Renewal Supply Start
  const [bindContraceptiveRenewalData, setBindContraceptiveRenewalData] =
    useState([]);

  const [bindContraceptiveRemarks, setBindContraceptiveRemarks] = useState([]);
  const [
    bindContraceptiveRemarksDiscontinued,
    setBindContraceptiveRemarksDiscontinued,
  ] = useState([]);

  const [contraceptiveNotificationId, setContraceptiveNotificationId] =
    useState("");
  const [contraceptiveDate, setContraceptiveDate] = useState("");
  const [contraceptiveServiceDate, setContraceptiveServiceDate] = useState("");
  const [contraceptiveClientId, setContraceptiveClientId] = useState("");
  const [fpMethod, setFPMethod] = useState("");
  const [serviceId, setServiceId] = useState("");

  const [contraceptiveRemarks, setContraceptiveRemarks] = useState("");
  const [
    contraceptiveRemarksDiscontinued,
    setContraceptiveRemarksDiscontinued,
  ] = useState("");
  const [contraceptiveNextFollowUpDate, setContraceptiveNextFollowUpDate] =
    useState("");

  // Referral Follow Up Start
  const [bindReferralFollowUpData, setBindReferralFollowUpData] = useState([]);
  const [bindReferralFollowUpRemarks, setBindReferralFollowUpRemarks] =
    useState([]);

  const [txnServicesId, setTxnServicesId] = useState("");
  const [referralDate, setReferralDate] = useState("");
  const [referralClientId, setReferralClientId] = useState("");
  const [referralService, setReferralService] = useState("");
  const [referralRemarks, setReferralRemarks] = useState("");

  // Common states
  const [rowIndexData, setRowIndexData] = useState("");
  const [clearNotificationValues, setClearNotificationValues] = useState(false);

  useEffect(() => {
    if (userProfileDatas?.length && call) {
      notificationData(userProfileDatas[0]);
    }
  }, [userProfileDatas, call]);

  const notificationData = async (user) => {

    if (!user) return;

    const data = {
      mstOrganizationStructureId: user.MstOrganizationId,
      mstBranchId: user.MstLocationId,
      mstSdpId: user.MstSDPId || 0,
      mstUserId: user.MstUserId,
      mstRoleId: user.MstRoleId,
    };

    try {
      // ✅ Call both APIs in parallel
      const [referralRes, contraceptiveRes] = await Promise.all([
        BindPostAPI([data], "NotificationAPI/BindReferralFollowUpNotification"),
        BindPostAPI([data], "NotificationAPI/BindContraceptiveNotification"),
      ]);

      console.log("Referral Response:", referralRes.data);
      console.log("Contraceptive Response:", contraceptiveRes.data);

      // ✅ Set states safely
      setBindContraceptiveRenewalData(
        contraceptiveRes.data?.Table ?? contraceptiveRes.data?.Table1 ?? []
      );
      setBindReferralFollowUpData(
        referralRes.data?.Table ?? referralRes.data?.Table1 ?? []
      );
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  };

  const handleNotificationData = (updatedData) => {
    updatedData.forEach((item) => {
      setRowIndexData(item.RowIndex);
      setTxnServicesId(item.TxnServicesId);
      setReferralDate(item.Date);
      setReferralClientId(item.ClientID);
      setReferralService(item.ReferralService);
      setReferralRemarks(item.Remarks);
    });
  };

  useEffect(() => {
    if (!call) return;
    const fetchRemarksDropdowns = async () => {
      try {
        setIsLoading(true);
        const [remarksResponse, discontinuedResponse, referralResponse] =
          await Promise.all([
            BindAPI("NotificationAPI/BindContraceptiveRemarks"),
            BindAPI("NotificationAPI/BindContraceptiveDiscontinuedRemarks"),
            BindAPI("NotificationAPI/BindReferralFollowUpRemarks"),
          ]);

        setBindContraceptiveRemarks(
          remarksResponse.data?.Table?.map((m) => ({
            value: m.MstContraceptiveRemarksId,
            label: m.Remarks_en,
          })) ?? []
        );

        setBindContraceptiveRemarksDiscontinued(
          discontinuedResponse.data?.Table?.map((m) => ({
            value: m.MstContraceptiveDiscontinuedRemarksId,
            label: m.Remarks_en,
          })) ?? []
        );

        setBindReferralFollowUpRemarks(
          referralResponse.data?.Table?.map((m) => ({
            value: m.MstReferralFollowUpRemarksId,
            label: m.Remarks_en,
          })) ?? []
        );
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching remarks dropdowns:", error);
      }
    };

    fetchRemarksDropdowns();
  }, [call]);

  const handleContraceptiveNotificationData = (updatedData) => {
    updatedData.forEach((item) => {
      setRowIndexData(item.RowIndex);
      setContraceptiveNotificationId(item.TxnContraceptiveNotificationId);
      setContraceptiveDate(item.Date);
      setContraceptiveServiceDate(item.ServiceDate);
      setContraceptiveClientId(item.ClientID);
      setFPMethod(item.FPMethod);
      setServiceId(item.TxnServicesId);

      setContraceptiveRemarks(item.Remarks);
      setContraceptiveRemarksDiscontinued(item.Remarks2);
      setContraceptiveNextFollowUpDate(item.NextFollowUpDate);
    });
  };

  const handleClearNotificationValues = (data) => {
    data && setClearNotificationValues(false);
  };

  const cancel = () => {
    setContraceptiveRemarks("");
    setContraceptiveRemarksDiscontinued("");
    setClearNotificationValues(true);
    setRowIndexData("");
    setContraceptiveNotificationId("");
    setContraceptiveDate("");
    setContraceptiveServiceDate("");
    setContraceptiveClientId("");
    setFPMethod("");
    setServiceId("");
    setIsLoading(false);

    setContraceptiveNextFollowUpDate("");

    setTxnServicesId("");
    setReferralDate("");
    setReferralClientId("");
    setReferralService("");
    setReferralRemarks("");

    notificationData(userProfileDatas[0]);
  };

  const HandleSubmit = async (rowIndex) => {
    debugger
    setIsLoading(true);
    if (rowIndex == rowIndexData) {
      if (
        contraceptiveRemarks === null ||
        contraceptiveRemarks === undefined ||
        contraceptiveRemarks.trim() === ""
      ) {
        toast.error("select Remarks");
        setIsLoading(false);
        setTimeout(cancel, 1000);
        return;
      }

      if (
        parseInt(contraceptiveRemarks) === 3
      ) {
        if (
          contraceptiveRemarksDiscontinued === null ||
          contraceptiveRemarksDiscontinued === undefined ||
          contraceptiveRemarksDiscontinued === ""
        ) {
          toast.error("select Reason");
          setIsLoading(false);
          setTimeout(cancel, 1000);
          return;
        }
      }

      const data = {
        txnContraceptiveNotificationId: contraceptiveNotificationId,
        date: contraceptiveDate,
        serviceDate: contraceptiveServiceDate,
        clientID: contraceptiveClientId,
        remarks: contraceptiveRemarks,
        remarksDiscontinued: contraceptiveRemarksDiscontinued || 0,
        fpMethod: fpMethod,
        txnServicesId: serviceId,
        nextFollowUp: contraceptiveNextFollowUpDate || null,
        createdBy: sessionStorage.getItem("createdBy"),
        flag: 1,
      };

      const response = await IUDAPI(
        [data],
        "NotificationAPI/IUDContraceptiveNotification"
      );

      if (response.data.Table[0].Result == "M") {
        toast.success("Contraceptive Notification saved successfully 👍");
        setTimeout(cancel, 1000);
      } else {
        toast.error("Contraceptive Notification insert failed 👎");
        setTimeout(cancel, 1000);
      }
    } else {
      toast.error("Please fill only one row 👎");
      setIsLoading(false);
      setTimeout(cancel, 1000);
    }
  };

  const HandleSubmit1 = async (rowIndex) => {
    setIsLoading(true);
    if (rowIndex == rowIndexData) {
      const data = {
        txnServicesId: txnServicesId,
        date: referralDate,
        clientID: referralClientId,
        remarks: referralRemarks,
        createdBy: sessionStorage.getItem("createdBy"),
        flag: 1,
      };

      const response = await IUDAPI(
        [data],
        "NotificationAPI/IUDReferralFollowUpNotification"
      );

      if (response.data.Table[0].Result == "M") {
        toast.success("Referral Follow Up saved successfully 👍");
        setTimeout(cancel, 3000);
      } else {
        toast.error("Referral Follow Up insert failed 👎");
        setTimeout(cancel, 3000);
      }
    } else {
      toast.error("Please fill only one row 👎");
      setIsLoading(false);
      setTimeout(cancel, 3000);
    }
  };
  const NotificationHeader = [
    { title: "S.No" },
    { title: "TxnContraceptiveNotificationId" },
    { title: "Date" },
    { title: "Service Date" },
    { title: "Client Name" },

    { title: "Client ID" },

    // SDP
    { title: "Mobile No." },

    // Area
    { title: "FP Method" },

    { title: "Remarks" },
    {
      title: "Reason"

    },

    { title: "Next Follow-up" },

    { title: "Created By" },
  ];
  const NotificationHeader1 = [
    { title: "S.No" },
    { title: "TxnReferralNotificationId" },
    { title: "Date" },
    { title: "Client Name" },
    { title: "Client ID" },

    { title: "Mobile No." },

    // SDP
    { title: "Referral Service" },

    // Area
    { title: "Remarks" },


    { title: "Created By" },
  ];
  const handleExport = async () => {


    // ✅ PASS ONLY STRING HEADERS (same as commodities)
    exportData(
      NotificationHeader.map((column) => column.title),
      bindContraceptiveRenewalData
    );

  };


  const exportData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Contraceptive Renewal Supply Follow Up",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column, // ✅ STRING ONLY
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: baseStyle },
        { v: rowData.TxnContraceptiveNotificationId || '- ', s: baseStyle },
        { v: rowData.FormattedDate || '- ', s: baseStyle },
        { v: rowData.FormattedServiceDate || '- ', s: baseStyle },
        { v: rowData.ClientFirstName_en || '- ', s: baseStyle },
        { v: rowData.ClientID || '- ', s: baseStyle },
        { v: rowData.ClientPhoneNo || '- ', s: baseStyle },
        { v: rowData.Services_en || '- ', s: baseStyle },
        { v: '-', s: baseStyle },
        { v: '-', s: baseStyle },
        { v: '-', s: baseStyle },
        { v: rowData.FullName_en || '- ', s: baseStyle },

      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 5 },   // S.No
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 30 },
      { width: 30 },

    ];

    /* ================= ROW HEIGHTS ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SDP Master");
    XLSX.writeFile(wb, "Contraceptive Renewal Supply Follow Up.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };


  const handleExport1 = async () => {


    // ✅ PASS ONLY STRING HEADERS (same as commodities)
    exportData1(
      NotificationHeader1.map((column) => column.title),
      bindReferralFollowUpData
    );

  };


  const exportData1 = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Referral Follow Up",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column, // ✅ STRING ONLY
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: baseStyle },
        { v: rowData.TxnReferralNotificationId || '- ', s: baseStyle },
        { v: rowData.FormattedDate || '- ', s: baseStyle },
        { v: rowData.ClientFirstName_en || '- ', s: baseStyle },
        { v: rowData.ClientID || '- ', s: baseStyle },
        { v: rowData.ClientPhoneNo || '- ', s: baseStyle },
        { v: rowData.ReferredTo_en || '- ', s: baseStyle },
        { v: '-', s: baseStyle },

        { v: rowData.FullName_en || '- ', s: baseStyle },

      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 5 },   // S.No
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 30 },

    ];

    /* ================= ROW HEIGHTS ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SDP Master");
    XLSX.writeFile(wb, "Referral Follow Up.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  return (
    <div className="w-full">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div className="">
        <div className="block mb-2 px-2 text-base capitalize font-bold text-neutral-700 ">
          Notifications
        </div>
        <div className="px-2 ">
          <hr className="h-px my-2 bg-red-600 border-0" />
        </div>

        <form className="overflow-y-scroll px-5 max-h-[72vh]">
          <GridPage
            title="Contraceptive Renewal Supply Follow Up"
            header={contraceptiveRSFHeader}
            records={bindContraceptiveRenewalData}
            bindContraceptiveRemarks={bindContraceptiveRemarks}
            bindDiscontinuedRemarks={bindContraceptiveRemarksDiscontinued}
            onContraceptiveNotificationDatas={
              handleContraceptiveNotificationData
            }
            onNotificationSave={HandleSubmit}
            onNotificationClear={clearNotificationValues}
            onNotificationClearFalse={handleClearNotificationValues}
            addView={true}
            handleExportBtn={true}
            handleExport={handleExport}
          />
        </form>

        <div className="px-2 ">
          <hr className="h-px my-2 bg-red-600 border-0" />
        </div>

        <form className="overflow-y-scroll px-5 max-h-[72vh]">
          <GridPage
            title="Referral Follow Up"
            header={ReferralFollowUpNotificationsHeader}
            records={bindReferralFollowUpData}
            onReferralFollowUpNotificationDatas={handleNotificationData}
            bindReferralFollowUpRemarks={bindReferralFollowUpRemarks}
            onNotificationSave={HandleSubmit1}
            onNotificationClear={clearNotificationValues}
            onNotificationClearFalse={handleClearNotificationValues}
            addView={true}
            handleExportBtn={true}
            handleExport={handleExport1}
          />
        </form>
      </div>
    </div>
  );
};

export default Notifications;
